import loadGA from "./src/loadGoogleAnalytics";
import loadGTM from "./src/loadGoogleTagManager";

export default {
	loadGA: loadGA._version,
	loadGTM: loadGTM._version
};

export { loadGA, loadGTM };
